import { useEffect, useState } from "react";
import { Search, MapPin } from "lucide-react";
import { api } from "@/lib/api";
import "./DiscoverPage.css";

export default function DiscoverPage() {
  const [items, setItems] = useState([]);
  const [cuisines, setCuisines] = useState([]);
  const [q, setQ] = useState("");
  const [cuisine, setCuisine] = useState("");
  const [openNow, setOpenNow] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = "Find a Restaurant — HustlePlate";
  }, []);

  useEffect(() => {
    const id = setTimeout(async () => {
      setLoading(true);
      try {
        const { data } = await api.get("/discover", {
          params: { q, cuisine, open_now: openNow, limit: 60 },
        });
        setItems(data.items || []);
        setCuisines(data.cuisines || []);
      } finally {
        setLoading(false);
      }
    }, 200);
    return () => clearTimeout(id);
  }, [q, cuisine, openNow]);

  return (
    <div className="dx-root" data-testid="discover-page">
      <header className="dx-hero">
        <h1>Find a restaurant.<br />Order, book, or just have a sticky beak.</h1>
        <p>Every restaurant on the platform, all in one place. No marketplace cut, no fluff — straight to the kitchen.</p>
      </header>
      <div className="dx-filters" data-testid="discover-filters">
        <input
          className="dx-search"
          placeholder="Search by name, cuisine or suburb"
          value={q} onChange={(e) => setQ(e.target.value)}
          data-testid="discover-search"
        />
        <button
          type="button" className={`dx-chip ${!cuisine ? "dx-chip--active" : ""}`}
          onClick={() => setCuisine("")} data-testid="discover-chip-all"
        >All</button>
        {cuisines.slice(0, 8).map((c) => (
          <button
            key={c} type="button"
            className={`dx-chip ${cuisine === c ? "dx-chip--active" : ""}`}
            onClick={() => setCuisine(cuisine === c ? "" : c)}
            data-testid={`discover-chip-${c.toLowerCase()}`}
          >{c}</button>
        ))}
        <button
          type="button" className={`dx-chip ${openNow ? "dx-chip--active" : ""}`}
          onClick={() => setOpenNow(!openNow)} data-testid="discover-open-now"
        >Open now</button>
      </div>
      <div className="dx-grid" data-testid="discover-grid">
        {loading && <p style={{ gridColumn: "1/-1", textAlign: "center", color: "#5C625E" }}>Loading…</p>}
        {!loading && items.length === 0 && (
          <div className="dx-empty" data-testid="discover-empty">
            <Search style={{ width: 40, height: 40, opacity: 0.4, marginBottom: 12 }} />
            <p>No restaurants match. Try a wider search.</p>
          </div>
        )}
        {items.map((b) => (
          <a
            key={b.id} href={`/?biz=${b.slug}`} className="dx-card"
            data-testid={`discover-card-${b.slug}`}
          >
            <div className="dx-card__img">{(b.business_name || "?")[0]}</div>
            <div className="dx-card__body">
              <div className="dx-card__name">{b.business_name}</div>
              <div className="dx-card__sub">
                <MapPin style={{ width: 12, height: 12, display: "inline", verticalAlign: -2 }} />{" "}
                {b.suburb || b.main_city || "Australia"} · {b.cuisine || ""}
              </div>
              <div className="dx-card__meta">
                {b.cuisine && <span className="dx-card__tag">{b.cuisine}</span>}
                {b.distance_km != null && <span className="dx-card__tag">{b.distance_km} km</span>}
              </div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}
